<template>
  <div class="noAudioDialog">
    <div class="titleGrid">
      <div class="close-btn" @click="hide('Close')">
        <i class="icon-popup-close"></i>
      </div>
    </div>

    <div class="content">视频中没有音频数据，无法进行字幕识别。</div>
  </div>
</template>

<script>
export default {
  name: "noAudioDialog",
  data() {
    return {};
  },
  props: {},
  components: {},
  methods: {
    hide(type) {
      this.$emit("resultHandler", { type: type });
    }
  },
  watch: {},
  computed: {}
};
</script>

<style scoped lang='scss'>
.noAudioDialog {
  position: relative;
  width: 540px;
  height: 129px;
  margin: auto;
  background-color: #fff;
  border-radius: 4px;

  .titleGrid {
    position: absolute;
    width: 100%;
    position: relative;
    height: 40px;

    .close-btn {
      position: absolute;
      top: 14px;
      right: 17px;
      cursor: pointer;
    }
  }
  .content {
    position: absolute;
    top: 57px;
    width: 100%;
    color: #333333;
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/subtitle/dialogs/noAudioDialog.vue